import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.v6config.V6Config.';
  public static readonly supplierSystemUpdate = `${Id.prefix}supplierSystemUpdate`;
  public static readonly forceReloadRequired = `${Id.prefix}forceReloadRequired`;
  public static readonly frameConfigRequiresReload = `${Id.prefix}frameConfigRequiresReload`;
  public static readonly pageReloadRequired = `${Id.prefix}pageReloadRequired`;
}

export class LangV6Config {
  private constructor() {}
  public static supplierSystemUpdate(): string {
    return interpolate(Id.supplierSystemUpdate);
  }
  public static forceReloadRequired(): string {
    return interpolate(Id.forceReloadRequired);
  }
  public static frameConfigRequiresReload(): string {
    return interpolate(Id.frameConfigRequiresReload);
  }
  public static pageReloadRequired(): string {
    return interpolate(Id.pageReloadRequired);
  }
}

export class V6ConfigModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.supplierSystemUpdate,
      "The {{glossary 'supplier'}} has updated their systems and the page requires a force reload now to update the systems",
      'Message for supplier system update requiring reload'
    );
    register.add(Id.forceReloadRequired, 'Force Reload Required', 'Dialog title for force reload required');
    register.add(
      Id.frameConfigRequiresReload,
      "{{glossary 'frame'}} configuration requires a page reload",
      'Message for frame config requiring reload'
    );
    register.add(Id.pageReloadRequired, 'Page reload required', 'Dialog title for page reload required');
  }
}
